import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components";

const Services = ({ siteTitle }) => (
    <section class="section">
        <h1 class="title">Þjónusta</h1>
        <p class="about-us-paragraph">Markmið Strendings ehf. er að veita persónulega og góða alhliða þjónustu á byggingarsviði.</p>
        <p class="about-us-paragraph">Í boði er þjónusta er lítur að umsjón með mannvirkjagerð eða hönnun mannvirkis, hvort sem um er að ræða einbýlishús, skóla, veg, höfn eða virkjun.</p>
        <p class="about-us-paragraph">Strendingur ehf getur meðal annars boðið þér þjónustu á eftirfarandi sviðum:</p>
        <div class="content">
            <ol type="1">
            <li>Umsjón og eftirlit með byggingaframkvæmdum allt frá hugmynd að fullbúnu verki.</li>
            <li>Alhliða verkefnastjórnun.</li>
            <li>Heildarhönnun húsbygginga þ.e. burðarþolshönnun, hönnun frárennslislagna, neysluvatnslagna, hitalagna, loftræsilagna og hreinsikerfa í sundlaugar.</li>
            <li>Hafnargerð, virkjanagerð, landmælingar, gatna- og vegagerð.</li>
            <li>Útboð á þjónustu s.s. ræstingar, akstur og almenn innkaup.</li>
            <li>Tæknileg ráðgjöf fyrir verktaka.</li>
            </ol>
        </div>
    </section>
)

export default Services